import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL } from "../../config.js";
import Pagination from "../Pagination/Paginations.js";
import DownloadButtons from "../DownloadButtons/DownloadButtons.js";
import EntriesSelector from "../Pagination/EntriesSelector";
import "../preloading.css";
import Select from 'react-select';

const OvertimeReport = () => {
  const today = new Date().toISOString().split("T")[0];

  const [user, setUser] = useState({
    start_date: today,
    end_date: today,
    dept_id: "0",
    overtime_status: "",
    action_type: "Fetch",
  });

  const [departments, setDepartments] = useState([]);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);

  const handelInput = (e) => {
    const { name, value } = e.target;
    setUser((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ Fetch departments
// ✅ Auto-handle all API response formats
const fetchDepartments = async () => {
  try {
    const res = await axios.get(API_BASE_URL + "/showdepartment", {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });

    let deptData = [];

    if (Array.isArray(res.data)) {
      // Case B: pure array
      deptData = res.data;
    } else if (res.data.departments) {
      // Case A: { departments: [...] }
      deptData = res.data.departments;
    } else if (res.data.data) {
      // Case C: { data: [...] }
      deptData = res.data.data;
    } else {
      toast.error("Unexpected response structure from /showdepartment");
      console.log("Raw Response:", res.data);
    }

    setDepartments(deptData);
  } catch (err) {
    console.error(err);
    toast.error("Failed to load departments");
  }
};

  useEffect(() => {
    fetchDepartments();
  }, []);

  // ✅ Fetch report data
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(
        API_BASE_URL + "/daily_overtime_report",
        {
          start_date: user.start_date,
          end_date: user.end_date,
          dept_id: user.dept_id,
          overtime_status: user.overtime_status,
          action_type: user.action_type,
        },
        { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
      );

      setRecords(res.data.records || []);
      setCurrentPage(1);
      setLoading(false);
      toast.success("Report loaded successfully!", {
        position: "bottom-right",
        theme: "colored",
      });
    } catch (error) {
      console.error(error);
      toast.error("Error fetching report data");
      setLoading(false);
    }
  };

  // ✅ Search + Pagination
  let filteredItems = records.filter((item) =>
    `${item.employee_id}${item.employee_name}${item.department}${item.shift_code}${item.overtime_date}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  return (
    <>
      <div className="container-fluid mt-4">
        <ToastContainer />

         <div className="mb-3 d-flex flex-wrap gap-2">
          <a href="/Overtime-report" className="btn btn-info btn-sm">
            Daily Overtime Report
          </a>
          <a href="/Monthly-Overtime" className="btn btn-outline-secondary btn-sm">
            Monthly Overtime Report
          </a>
        </div>
        <div className="card shadow-sm mb-4">
          <div className="card-header with-elements">
            <span className="card-header-title me-2">Daily Overtime Report</span>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row g-3 align-items-end">
                {/* From Date */}
                <div className="col-md-2">
                  <label htmlFor="start_date">From Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="start_date"
                    value={user.start_date}
                    onChange={handelInput}
                    required
                  />
                </div>

                {/* To Date */}
                <div className="col-md-2">
                  <label htmlFor="end_date">To Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="end_date"
                    value={user.end_date}
                    onChange={handelInput}
                    required
                  />
                </div>

                {/* Department */}
                <div className="col-md-3">
                  <label htmlFor="dept_id">Department</label>
                 <Select
    name="dept_id"
    value={departments
      .map((dept) => ({
        value: dept.department_id || dept.id,
        label: dept.department_name,
      }))
      .find((d) => d.value === user.dept_id) || null}
    onChange={(selected) =>
      handelInput({
        target: { name: "dept_id", value: selected ? selected.value : "" },
      })
    }
    options={departments.map((dept) => ({
      value: dept.department_id || dept.id,
      label: dept.department_name,
    }))}
    isClearable
    placeholder="All Department"
    className="basic-single"
  />
                </div>

                {/* Overtime Status */}
                <div className="col-md-2">
                  <label htmlFor="overtime_status">Overtime Status</label>
                  <select
                    className="form-control"
                    name="overtime_status"
                    value={user.overtime_status}
                    onChange={handelInput}
                    required
                  >
                    <option value="">Select</option>
                    <option value="0">Cancelled</option>
                    <option value="2">Approved</option>
                    <option value="3">Rejected</option>
                  </select>
                </div>

                {/* Action */}
                {/* <div className="col-md-2">
                  <label htmlFor="action_type">Action</label>
                  <select
                    className="form-control"
                    name="action_type"
                    value={user.action_type}
                    onChange={handelInput}
                  >
                    <option value="Fetch">Show</option>
                  </select>
                </div> */}

                {/* Submit */}
                <div className="col-md-2">
                  <button type="submit" className="btn btn-primary w-100">
                    Get
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* 🔹 Table */}
        <div className="card">
          <h6 className="card-header text-danger">
            Kindly Calculate OT Amount = Per hour * Calc Point
          </h6>
          <div className="card-body">
            <div className="d-flex justify-content-between mb-2">
           
        <div
  className="d-flex align-items-center gap-2"
  style={{ width: "auto", minWidth: "220px" }}
>
  <DownloadButtons data={filteredItems} filename="Daily Overtime" />

  <EntriesSelector
    setEntriesPerPage={setEntriesPerPage}
    setCurrentPage={setCurrentPage}
    className="form-select form-select-sm"
  />
</div>


              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Search..."
                style={{ width: "200px" }}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            {loading ? (
              <div className="d-flex justify-content-center p-5">
                <div className="spinner"></div>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead style={{ backgroundColor: "#7d858369" }}>
                    <tr>
                      <th>Employee ID</th>
                      <th>Employee Name</th>
                      <th>Shift Code</th>
                      <th>Department</th>
                      <th>No of Hours</th>
                      <th>Calc Point</th>
                      <th>Per Hour</th>
                      <th>Amount</th>
                      <th>Actual Amount</th>
                      <th>Overtime Date</th>
                      <th>Incharge</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.length > 0 ? (
                      filteredData.map((row, idx) => (
                        <tr key={idx}>
                          <td>{row.employee_id}</td>
                          <td>{row.employee_name}</td>
                          <td>{row.shift_code}</td>
                          <td>{row.department}</td>
                          <td>{row.no_of_hour}</td>
                          <td>{row.calc_point}</td>
                          <td>{row.per_hour}</td>
                          <td>{row.amount}</td>
                          <td>{row.actual_amount}</td>
                          <td>{row.overtime_date}</td>
                          <td>{row.incharge_name}</td>
                          <td>{row.status}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="12" className="text-center text-danger fw-bold">
                          No records found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default OvertimeReport;
